import React from 'react';
import Label from '~/src/atoms/Label/';
import tw from 'twin.macro';
import Image from '~/src/atoms/Image';
import { Utils } from '~/libs/utils';
import useSelectedPack from './useSelectedPack';

const BBstarPrice = ({ isBBstar = false, showBBstar = true, ...rest }) => {
  const { pricing = {} } = useSelectedPack();

  if (!isBBstar || !showBBstar) {
    return <div className="w-full py-3"></div>;
  }

  if (!Utils.isEmpty(pricing)) {
    return (
      <div css={tw`border border-dashed border-silverSurfer-900 h-6 rounded-2xl overflow-hidden`} {...rest}>
        <div className="linear-background flex justify-start items-center h-full">
          <Image
            alt="bb-star"
            width={20}
            height={20}
            src={Utils.urlJoin(
              pricing?.discount?.sec_price?.icon?.base_url,
              pricing?.discount?.sec_price?.icon?.image,
              pricing?.discount?.sec_price?.icon?.format
            )}
          />
          <div className={'flex justify-start items-center'}>
            <Label css={tw`text-sm text-darkOnyx-500`}>{pricing?.discount?.sec_price?.desc}:&nbsp;</Label>
            <Label css={tw`font-bold`}>{`₹${pricing?.discount?.sec_price?.sp}`}</Label>
          </div>
          <style>{`
            .linear-background {
              background-image: linear-gradient(to right, #ffffff, #eeeff1);
            }
          `}</style>
        </div>
      </div>
    );
  } else return <></>;
};

export default BBstarPrice;
